import axios from "axios";
import { toast } from "sonner";
import { backendUrl } from "./api";

/**
 * Offline action queue — safe, non-payment writes made while offline are
 * queued in localStorage and automatically replayed when connectivity
 * returns. Payment/PIN actions are intentionally excluded (require network).
 */
const KEY = "icaard_offline_queue";

// Only these write endpoints are safe to replay later.
const QUEUEABLE = [
  /^\/money\/favorites\//,
  /^\/notifications\//,
  /^\/banners\/.+\/(view|click)$/,
  /^\/admin\/ads\/.+\/click$/,
  /^\/profile/,
];

export const isQueueable = (url, method) =>
  ["post", "put", "patch"].includes((method || "").toLowerCase()) &&
  QUEUEABLE.some((re) => re.test(url || ""));

const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
const write = (q) => localStorage.setItem(KEY, JSON.stringify(q.slice(-50)));

export function enqueue({ method, url, data }) {
  const q = read();
  q.push({ method, url, data, at: Date.now() });
  write(q);
}

let flushing = false;
export async function flushQueue() {
  if (flushing || !navigator.onLine) return;
  const q = read();
  if (!q.length) return;
  flushing = true;
  const token = localStorage.getItem("icard_token");
  const client = axios.create({
    baseURL: `${backendUrl}/api`,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  const remaining = [];
  for (const item of q) {
    try {
      await client.request({ method: item.method, url: item.url, data: item.data });
    } catch (e) {
      if (!e.response) remaining.push(item); // still offline — keep
      // 4xx/5xx responses: drop (stale action)
    }
  }
  write(remaining);
  flushing = false;
  if (remaining.length < q.length) {
    toast.success(`Synced ${q.length - remaining.length} offline action${q.length - remaining.length !== 1 ? "s" : ""} ✓`);
  }
}

export function initOfflineSync() {
  window.addEventListener("online", () => setTimeout(flushQueue, 1500));
  setTimeout(flushQueue, 4000);
}
